<template>
  <v-select
    :label="$t('ReceiptBillAnalyze.billTypes.title')"
    v-model="model"
    :items="billTypes"
    clearable
    @change="$emit('change')"
  ></v-select>
</template>

<script>
import consts from "@/consts.js";

export default {
  name: "SearcherSupplyType",
  props: { 
    value:Number,
    objType:Number
   },
  computed: {
    billTypes() {
      if(this.objType == 1){
        return consts.billTypes;
      } else if (this.objType == 2){
        return consts.purchaseBillTypes
      } else if (this.objType == 3) {
        return consts.stockBillTypes
      } else {
        return []
      }
    },
  },

  data: () => ({
    model: null,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
